import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=7c221a42&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c221a42",
  null
  
)

export default component.exports